import _definePage_default_0 from '/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/index.vue?definePage&vue'
import { _mergeRouteRecord } from 'unplugin-vue-router/runtime'
import _definePage_default_2 from '/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/[...404].vue?definePage&vue'
import _definePage_default_3 from '/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/[...error].vue?definePage&vue'
import _definePage_default_4 from '/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/access-control.vue?definePage&vue'
import _definePage_default_5 from '/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/erp/de/select/view/[tabId].vue?definePage&vue'
import _definePage_default_6 from '/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/erp/de/select/view/de-select.vue?definePage&vue'
import _definePage_default_7 from '/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/erp/de/select/view/de-table.vue?definePage&vue'
import _definePage_default_8 from '/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/erp/ds/auth/view/[roleId].vue?definePage&vue'
import _definePage_default_9 from '/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/erp/ds/auth/view/ds-auth.vue?definePage&vue'
import _definePage_default_10 from '/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/erp/ds/auth/view/ds-authMember.vue?definePage&vue'
import _definePage_default_11 from '/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/erp/ds/auth/view/ds-dataAuth.vue?definePage&vue'
import _definePage_default_12 from '/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/erp/ds/auth/view/ds-dataAuthClass.vue?definePage&vue'
import _definePage_default_13 from '/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/erp/ds/auth/view/ds-group.vue?definePage&vue'
import _definePage_default_14 from '/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/erp/ds/auth/view/ds-groupMember.vue?definePage&vue'
import _definePage_default_15 from '/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/erp/ds/auth/view/ds-role.vue?definePage&vue'
import _definePage_default_16 from '/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/erp/ds/menu/view/ds-action-auth.vue?definePage&vue'
import _definePage_default_17 from '/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/erp/ds/menu/view/ds-menu.vue?definePage&vue'
import _definePage_default_18 from '/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/erp/ds/menu/view/ds-sys.vue?definePage&vue'
import _definePage_default_19 from '/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/erp/ds/token/view/ds-apiToken.vue?definePage&vue'
import _definePage_default_20 from '/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/erp/du/org/view/du-class.vue?definePage&vue'
import _definePage_default_21 from '/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/erp/du/org/view/du-department.vue?definePage&vue'
import _definePage_default_22 from '/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/erp/du/org/view/du-org.vue?definePage&vue'
import _definePage_default_23 from '/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/erp/du/org/view/du-position.vue?definePage&vue'
import _definePage_default_24 from '/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/erp/du/org/view/du-sub-org.vue?definePage&vue'
import _definePage_default_25 from '/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/erp/du/user/view/assignee-proxy-list.vue?definePage&vue'
import _definePage_default_26 from '/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/erp/du/user/view/assignee-proxy-setting.vue?definePage&vue'
import _definePage_default_27 from '/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/erp/du/user/view/du-approve.vue?definePage&vue'
import _definePage_default_28 from '/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/erp/du/user/view/du-user.vue?definePage&vue'
import _definePage_default_29 from '/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/erp/du/user/view/du-user-management.vue?definePage&vue'
import _definePage_default_30 from '/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/erp/du/user/view/du-userRegister.vue?definePage&vue'
import _definePage_default_31 from '/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/erp/du/user/view/updatepwd.vue?definePage&vue'
import _definePage_default_32 from '/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/erp/dw/msg/view/dw-msg.vue?definePage&vue'
import _definePage_default_33 from '/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/forgot-password.vue?definePage&vue'
import _definePage_default_34 from '/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/home.vue?definePage&vue'
import _definePage_default_35 from '/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/login.vue?definePage&vue'
import _definePage_default_36 from '/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/login-linebot.vue?definePage&vue'
import _definePage_default_37 from '/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/not-authorized.vue?definePage&vue'
import _definePage_default_38 from '/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/nstc/view/bulletin.vue?definePage&vue'
import _definePage_default_39 from '/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/nstc/view/rtp.vue?definePage&vue'
import _definePage_default_40 from '/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/register.vue?definePage&vue'
import _definePage_default_41 from '/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/register-result.vue?definePage&vue'
import _definePage_default_42 from '/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/reset/[key].vue?definePage&vue'
import _definePage_default_43 from '/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/reset-passwd.vue?definePage&vue'
import _definePage_default_44 from '/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/tca/index.vue?definePage&vue'
import _definePage_default_45 from '/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/tca/erm/AnnualExpenseSummary.vue?definePage&vue'
import _definePage_default_46 from '/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/tca/erm/AssociationBudgetExpense.vue?definePage&vue'
import _definePage_default_47 from '/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/tca/erm/AssociationBudgetSchedule.vue?definePage&vue'
import _definePage_default_48 from '/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/tca/erm/ExpenseBorrow.vue?definePage&vue'
import _definePage_default_49 from '/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/tca/erm/ExpenseBorrowCenterList.vue?definePage&vue'
import _definePage_default_50 from '/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/tca/erm/ExpenseBorrowList.vue?definePage&vue'
import _definePage_default_51 from '/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/tca/erm/expenseChange/ExpenseChangeMain.vue?definePage&vue'
import _definePage_default_52 from '/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/tca/erm/ExpenseChange.vue?definePage&vue'
import _definePage_default_53 from '/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/tca/erm/ExpenseChangeCenterList.vue?definePage&vue'
import _definePage_default_54 from '/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/tca/erm/ExpenseChangeList.vue?definePage&vue'
import _definePage_default_55 from '/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/tca/erm/ExpenseChangeReassign.vue?definePage&vue'
import _definePage_default_56 from '/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/tca/erm/ExpenseChangeSchedule.vue?definePage&vue'
import _definePage_default_57 from '/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/tca/erm/ExpenseReimbursement.vue?definePage&vue'
import _definePage_default_58 from '/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/tca/erm/ExpenseReimbursementCenterList.vue?definePage&vue'
import _definePage_default_59 from '/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/tca/erm/ExpenseReimbursementList.vue?definePage&vue'
import _definePage_default_60 from '/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/tca/erm/ExpenseReimbursementReassign.vue?definePage&vue'
import _definePage_default_61 from '/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/tca/erm/ExpenseRequest.vue?definePage&vue'
import _definePage_default_62 from '/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/tca/erm/ExpenseRequestCenterList.vue?definePage&vue'
import _definePage_default_63 from '/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/tca/erm/ExpenseRequestList.vue?definePage&vue'
import _definePage_default_64 from '/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/tca/erm/ExpenseRequestMain.vue?definePage&vue'
import _definePage_default_65 from '/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/tca/erm/ExpenseRequestProject.vue?definePage&vue'
import _definePage_default_66 from '/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/tca/erm/ExpenseRequestProjectCenterList.vue?definePage&vue'
import _definePage_default_67 from '/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/tca/erm/ExpenseRequestProjectList.vue?definePage&vue'
import _definePage_default_68 from '/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/tca/erm/ExpenseRequestReassign.vue?definePage&vue'
import _definePage_default_69 from '/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/tca/erm/GoldPlanApply.vue?definePage&vue'
import _definePage_default_70 from '/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/tca/erm/GoldPlanAthleteList.vue?definePage&vue'
import _definePage_default_71 from '/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/tca/erm/GoldPlanMeetingRecords.vue?definePage&vue'
import _definePage_default_72 from '/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/tca/erm/PaymentVoucherConfirm.vue?definePage&vue'
import _definePage_default_73 from '/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/tca/erm/PaymentVoucherUpload.vue?definePage&vue'
import _definePage_default_74 from '/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/tca/erm/ReassignApplication.vue?definePage&vue'
import _definePage_default_75 from '/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/tca/erm/UserInfoComponent.vue?definePage&vue'
import _definePage_default_76 from '/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/tca/tnm/AssociationAutoCompleteComponenet.vue?definePage&vue'
import _definePage_default_77 from '/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/tca/tnm/AssociationCounselorSettings.vue?definePage&vue'
import _definePage_default_78 from '/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/tca/tnm/CountryAreaCode.vue?definePage&vue'
import _definePage_default_79 from '/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/tca/tnm/ExpensePerDiem.vue?definePage&vue'
import _definePage_default_80 from '/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/tca/tnm/FnAssociationCounselorSettings.vue?definePage&vue'
import _definePage_default_81 from '/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/tca/tnm/PlanProjectListQuery.vue?definePage&vue'
import _definePage_default_82 from '/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/tca/tnm/ProjectCreationAndPublication.vue?definePage&vue'
import _definePage_default_83 from '/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/tca/tnm/ProjectListCenter.vue?definePage&vue'
import _definePage_default_84 from '/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/tca/tnm/ProjectScheduleManagement.vue?definePage&vue'
import _definePage_default_85 from '/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/tca/tnm/ReimburseItem.vue?definePage&vue'
import _definePage_default_86 from '/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/tca/tnm/StatusComponenet.vue?definePage&vue'
import _definePage_default_87 from '/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/tca/tnm/TrainingApplicationList.vue?definePage&vue'
import _definePage_default_88 from '/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/tca/tnm/TrainingApplicationQueryList.vue?definePage&vue'
import _definePage_default_89 from '/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/tca/tnm/TrainingListPrint.vue?definePage&vue'
import _definePage_default_90 from '/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/tca/tnm/TrainingPlanApplication.vue?definePage&vue'
import _definePage_default_91 from '/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/tca/tnm/TrainingPlanApplicationList.vue?definePage&vue'
import _definePage_default_92 from '/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/tca/tnm/TrainingPlanApplicationListAssociation.vue?definePage&vue'
import _definePage_default_93 from '/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/tca/tnm/TrainingTeamApplication.vue?definePage&vue'
import _definePage_default_94 from '/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/tca/tnm/UserInfoComponent.vue?definePage&vue'
import _definePage_default_95 from '/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/tca-home.vue?definePage&vue'

export const routes = [
  _mergeRouteRecord(
  {
    path: '/',
    name: 'root',
    component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/index.vue'),
    /* no children */
  },
  _definePage_default_0
  ),
  _mergeRouteRecord(
  {
    path: '/:404(.*)',
    name: '$404',
    component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/[...404].vue'),
    /* no children */
  },
  _definePage_default_2
  ),
  _mergeRouteRecord(
  {
    path: '/:error(.*)',
    name: '$error',
    component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/[...error].vue'),
    /* no children */
  },
  _definePage_default_3
  ),
  {
    path: '/about-us',
    name: 'about-us',
    component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/about-us.vue'),
    /* no children */
  },
  _mergeRouteRecord(
  {
    path: '/access-control',
    name: 'access-control',
    component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/access-control.vue'),
    /* no children */
  },
  _definePage_default_4
  ),
  {
    path: '/ds',
    /* internal name: 'ds' */
    /* no component */
    children: [
      {
        path: 'ds-index',
        name: 'ds-ds-index',
        component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/ds/ds-index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/erp',
    /* internal name: 'erp' */
    /* no component */
    children: [
      {
        path: 'de',
        /* internal name: 'erp-de' */
        /* no component */
        children: [
          {
            path: 'select',
            /* internal name: 'erp-de-select' */
            /* no component */
            children: [
              {
                path: 'view',
                /* internal name: 'erp-de-select-view' */
                /* no component */
                children: [
  _mergeRouteRecord(
                  {
                    path: ':tabId',
                    name: 'erp-de-select-view-tab-id',
                    component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/erp/de/select/view/[tabId].vue'),
                    /* no children */
                  },
  _definePage_default_5
  ),
  _mergeRouteRecord(
                  {
                    path: 'de-select',
                    name: 'erp-de-select-view-de-select',
                    component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/erp/de/select/view/de-select.vue'),
                    /* no children */
                  },
  _definePage_default_6
  ),
                  {
                    path: 'de-select-drawer',
                    name: 'erp-de-select-view-de-select-drawer',
                    component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/erp/de/select/view/de-select-drawer.vue'),
                    /* no children */
                  },
  _mergeRouteRecord(
                  {
                    path: 'de-table',
                    name: 'erp-de-select-view-de-table',
                    component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/erp/de/select/view/de-table.vue'),
                    /* no children */
                  },
  _definePage_default_7
  )
                ],
              }
            ],
          }
        ],
      },
      {
        path: 'ds',
        /* internal name: 'erp-ds' */
        /* no component */
        children: [
          {
            path: 'auth',
            /* internal name: 'erp-ds-auth' */
            /* no component */
            children: [
              {
                path: 'view',
                /* internal name: 'erp-ds-auth-view' */
                /* no component */
                children: [
                  {
                    path: '_ds-role-action',
                    name: 'erp-ds-auth-view-ds-role-action',
                    component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/erp/ds/auth/view/_ds-role-action.vue'),
                    /* no children */
                  },
                  {
                    path: '_ds-role-apps',
                    name: 'erp-ds-auth-view-ds-role-apps',
                    component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/erp/ds/auth/view/_ds-role-apps.vue'),
                    /* no children */
                  },
  _mergeRouteRecord(
                  {
                    path: ':roleId',
                    name: 'erp-ds-auth-view-role-id',
                    component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/erp/ds/auth/view/[roleId].vue'),
                    /* no children */
                  },
  _definePage_default_8
  ),
  _mergeRouteRecord(
                  {
                    path: 'ds-auth',
                    name: 'erp-ds-auth-view-ds-auth',
                    component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/erp/ds/auth/view/ds-auth.vue'),
                    /* no children */
                  },
  _definePage_default_9
  ),
                  {
                    path: 'ds-auth-drawer',
                    name: 'erp-ds-auth-view-ds-auth-drawer',
                    component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/erp/ds/auth/view/ds-auth-drawer.vue'),
                    /* no children */
                  },
  _mergeRouteRecord(
                  {
                    path: 'ds-authMember',
                    name: 'erp-ds-auth-view-ds-auth-member',
                    component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/erp/ds/auth/view/ds-authMember.vue'),
                    /* no children */
                  },
  _definePage_default_10
  ),
                  {
                    path: 'ds-authMember-drawer',
                    name: 'erp-ds-auth-view-ds-auth-member-drawer',
                    component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/erp/ds/auth/view/ds-authMember-drawer.vue'),
                    /* no children */
                  },
  _mergeRouteRecord(
                  {
                    path: 'ds-dataAuth',
                    name: 'erp-ds-auth-view-ds-data-auth',
                    component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/erp/ds/auth/view/ds-dataAuth.vue'),
                    /* no children */
                  },
  _definePage_default_11
  ),
                  {
                    path: 'ds-dataAuth-drawer',
                    name: 'erp-ds-auth-view-ds-data-auth-drawer',
                    component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/erp/ds/auth/view/ds-dataAuth-drawer.vue'),
                    /* no children */
                  },
  _mergeRouteRecord(
                  {
                    path: 'ds-dataAuthClass',
                    name: 'erp-ds-auth-view-ds-data-auth-class',
                    component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/erp/ds/auth/view/ds-dataAuthClass.vue'),
                    /* no children */
                  },
  _definePage_default_12
  ),
                  {
                    path: 'ds-dataAuthClass-drawer',
                    name: 'erp-ds-auth-view-ds-data-auth-class-drawer',
                    component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/erp/ds/auth/view/ds-dataAuthClass-drawer.vue'),
                    /* no children */
                  },
  _mergeRouteRecord(
                  {
                    path: 'ds-group',
                    name: 'erp-ds-auth-view-ds-group',
                    component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/erp/ds/auth/view/ds-group.vue'),
                    /* no children */
                  },
  _definePage_default_13
  ),
                  {
                    path: 'ds-group-drawer',
                    name: 'erp-ds-auth-view-ds-group-drawer',
                    component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/erp/ds/auth/view/ds-group-drawer.vue'),
                    /* no children */
                  },
  _mergeRouteRecord(
                  {
                    path: 'ds-groupMember',
                    name: 'erp-ds-auth-view-ds-group-member',
                    component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/erp/ds/auth/view/ds-groupMember.vue'),
                    /* no children */
                  },
  _definePage_default_14
  ),
                  {
                    path: 'ds-groupMember-drawer',
                    name: 'erp-ds-auth-view-ds-group-member-drawer',
                    component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/erp/ds/auth/view/ds-groupMember-drawer.vue'),
                    /* no children */
                  },
  _mergeRouteRecord(
                  {
                    path: 'ds-role',
                    name: 'erp-ds-auth-view-ds-role',
                    component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/erp/ds/auth/view/ds-role.vue'),
                    /* no children */
                  },
  _definePage_default_15
  ),
                  {
                    path: 'ds-role-dialog',
                    name: 'erp-ds-auth-view-ds-role-dialog',
                    component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/erp/ds/auth/view/ds-role-dialog.vue'),
                    /* no children */
                  },
                  {
                    path: 'ds-role-member',
                    name: 'erp-ds-auth-view-ds-role-member',
                    component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/erp/ds/auth/view/ds-role-member.vue'),
                    /* no children */
                  }
                ],
              }
            ],
          },
          {
            path: 'menu',
            /* internal name: 'erp-ds-menu' */
            /* no component */
            children: [
              {
                path: 'view',
                /* internal name: 'erp-ds-menu-view' */
                /* no component */
                children: [
                  {
                    path: ':id',
                    name: 'erp-ds-menu-view-id',
                    component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/erp/ds/menu/view/[id].vue'),
                    /* no children */
                  },
  _mergeRouteRecord(
                  {
                    path: 'ds-action-auth',
                    name: 'erp-ds-menu-view-ds-action-auth',
                    component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/erp/ds/menu/view/ds-action-auth.vue'),
                    /* no children */
                  },
  _definePage_default_16
  ),
                  {
                    path: 'ds-action-dialog',
                    name: 'erp-ds-menu-view-ds-action-dialog',
                    component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/erp/ds/menu/view/ds-action-dialog.vue'),
                    /* no children */
                  },
                  {
                    path: 'ds-action-member',
                    name: 'erp-ds-menu-view-ds-action-member',
                    component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/erp/ds/menu/view/ds-action-member.vue'),
                    /* no children */
                  },
                  {
                    path: 'ds-app-dialog',
                    name: 'erp-ds-menu-view-ds-app-dialog',
                    component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/erp/ds/menu/view/ds-app-dialog.vue'),
                    /* no children */
                  },
                  {
                    path: 'ds-group-member',
                    name: 'erp-ds-menu-view-ds-group-member',
                    component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/erp/ds/menu/view/ds-group-member.vue'),
                    /* no children */
                  },
  _mergeRouteRecord(
                  {
                    path: 'ds-menu',
                    name: 'erp-ds-menu-view-ds-menu',
                    component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/erp/ds/menu/view/ds-menu.vue'),
                    /* no children */
                  },
  _definePage_default_17
  ),
                  {
                    path: 'ds-menu-drawer',
                    name: 'erp-ds-menu-view-ds-menu-drawer',
                    component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/erp/ds/menu/view/ds-menu-drawer.vue'),
                    /* no children */
                  },
  _mergeRouteRecord(
                  {
                    path: 'ds-sys',
                    name: 'erp-ds-menu-view-ds-sys',
                    component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/erp/ds/menu/view/ds-sys.vue'),
                    /* no children */
                  },
  _definePage_default_18
  ),
                  {
                    path: 'ds-sys-dialog',
                    name: 'erp-ds-menu-view-ds-sys-dialog',
                    component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/erp/ds/menu/view/ds-sys-dialog.vue'),
                    /* no children */
                  }
                ],
              }
            ],
          },
          {
            path: 'token',
            /* internal name: 'erp-ds-token' */
            /* no component */
            children: [
              {
                path: 'view',
                /* internal name: 'erp-ds-token-view' */
                /* no component */
                children: [
  _mergeRouteRecord(
                  {
                    path: 'ds-apiToken',
                    name: 'erp-ds-token-view-ds-api-token',
                    component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/erp/ds/token/view/ds-apiToken.vue'),
                    /* no children */
                  },
  _definePage_default_19
  ),
                  {
                    path: 'ds-apiToken-drawer',
                    name: 'erp-ds-token-view-ds-api-token-drawer',
                    component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/erp/ds/token/view/ds-apiToken-drawer.vue'),
                    /* no children */
                  }
                ],
              }
            ],
          }
        ],
      },
      {
        path: 'du',
        /* internal name: 'erp-du' */
        /* no component */
        children: [
          {
            path: 'org',
            /* internal name: 'erp-du-org' */
            /* no component */
            children: [
              {
                path: 'view',
                /* internal name: 'erp-du-org-view' */
                /* no component */
                children: [
                  {
                    path: 'du-add-edit-org',
                    name: 'erp-du-org-view-du-add-edit-org',
                    component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/erp/du/org/view/du-add-edit-org.vue'),
                    /* no children */
                  },
  _mergeRouteRecord(
                  {
                    path: 'du-class',
                    name: 'erp-du-org-view-du-class',
                    component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/erp/du/org/view/du-class.vue'),
                    /* no children */
                  },
  _definePage_default_20
  ),
                  {
                    path: 'du-class-drawer',
                    name: 'erp-du-org-view-du-class-drawer',
                    component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/erp/du/org/view/du-class-drawer.vue'),
                    /* no children */
                  },
  _mergeRouteRecord(
                  {
                    path: 'du-department',
                    name: 'erp-du-org-view-du-department',
                    component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/erp/du/org/view/du-department.vue'),
                    /* no children */
                  },
  _definePage_default_21
  ),
                  {
                    path: 'du-department-drawer',
                    name: 'erp-du-org-view-du-department-drawer',
                    component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/erp/du/org/view/du-department-drawer.vue'),
                    /* no children */
                  },
  _mergeRouteRecord(
                  {
                    path: 'du-org',
                    name: 'erp-du-org-view-du-org',
                    component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/erp/du/org/view/du-org.vue'),
                    /* no children */
                  },
  _definePage_default_22
  ),
                  {
                    path: 'du-org-memberchange-dialog',
                    name: 'erp-du-org-view-du-org-memberchange-dialog',
                    component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/erp/du/org/view/du-org-memberchange-dialog.vue'),
                    /* no children */
                  },
  _mergeRouteRecord(
                  {
                    path: 'du-position',
                    name: 'erp-du-org-view-du-position',
                    component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/erp/du/org/view/du-position.vue'),
                    /* no children */
                  },
  _definePage_default_23
  ),
                  {
                    path: 'du-position-drawer',
                    name: 'erp-du-org-view-du-position-drawer',
                    component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/erp/du/org/view/du-position-drawer.vue'),
                    /* no children */
                  },
                  {
                    path: 'du-sign-level-dialog',
                    name: 'erp-du-org-view-du-sign-level-dialog',
                    component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/erp/du/org/view/du-sign-level-dialog.vue'),
                    /* no children */
                  },
  _mergeRouteRecord(
                  {
                    path: 'du-sub-org',
                    name: 'erp-du-org-view-du-sub-org',
                    component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/erp/du/org/view/du-sub-org.vue'),
                    /* no children */
                  },
  _definePage_default_24
  )
                ],
              }
            ],
          },
          {
            path: 'user',
            /* internal name: 'erp-du-user' */
            /* no component */
            children: [
              {
                path: 'view',
                /* internal name: 'erp-du-user-view' */
                /* no component */
                children: [
  _mergeRouteRecord(
                  {
                    path: 'assignee-proxy-list',
                    name: 'erp-du-user-view-assignee-proxy-list',
                    component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/erp/du/user/view/assignee-proxy-list.vue'),
                    /* no children */
                  },
  _definePage_default_25
  ),
  _mergeRouteRecord(
                  {
                    path: 'assignee-proxy-setting',
                    name: 'erp-du-user-view-assignee-proxy-setting',
                    component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/erp/du/user/view/assignee-proxy-setting.vue'),
                    /* no children */
                  },
  _definePage_default_26
  ),
  _mergeRouteRecord(
                  {
                    path: 'du-approve',
                    name: 'erp-du-user-view-du-approve',
                    component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/erp/du/user/view/du-approve.vue'),
                    /* no children */
                  },
  _definePage_default_27
  ),
                  {
                    path: 'du-management-export-dialog',
                    name: 'erp-du-user-view-du-management-export-dialog',
                    component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/erp/du/user/view/du-management-export-dialog.vue'),
                    /* no children */
                  },
  _mergeRouteRecord(
                  {
                    path: 'du-user',
                    name: 'erp-du-user-view-du-user',
                    component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/erp/du/user/view/du-user.vue'),
                    /* no children */
                  },
  _definePage_default_28
  ),
                  {
                    path: 'du-user-drawer',
                    name: 'erp-du-user-view-du-user-drawer',
                    component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/erp/du/user/view/du-user-drawer.vue'),
                    /* no children */
                  },
  _mergeRouteRecord(
                  {
                    path: 'du-user-management',
                    name: 'erp-du-user-view-du-user-management',
                    component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/erp/du/user/view/du-user-management.vue'),
                    /* no children */
                  },
  _definePage_default_29
  ),
                  {
                    path: 'du-user-management-drawer',
                    name: 'erp-du-user-view-du-user-management-drawer',
                    component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/erp/du/user/view/du-user-management-drawer.vue'),
                    /* no children */
                  },
  _mergeRouteRecord(
                  {
                    path: 'du-userRegister',
                    name: 'erp-du-user-view-du-user-register',
                    component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/erp/du/user/view/du-userRegister.vue'),
                    /* no children */
                  },
  _definePage_default_30
  ),
                  {
                    path: 'du-userRegister-compare-dialog',
                    name: 'erp-du-user-view-du-user-register-compare-dialog',
                    component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/erp/du/user/view/du-userRegister-compare-dialog.vue'),
                    /* no children */
                  },
                  {
                    path: 'du-userRegister-dialog',
                    name: 'erp-du-user-view-du-user-register-dialog',
                    component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/erp/du/user/view/du-userRegister-dialog.vue'),
                    /* no children */
                  },
                  {
                    path: 'du-userRegister-drawer',
                    name: 'erp-du-user-view-du-user-register-drawer',
                    component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/erp/du/user/view/du-userRegister-drawer.vue'),
                    /* no children */
                  },
                  {
                    path: 'EditUserDrawer',
                    name: 'erp-du-user-view-edit-user-drawer',
                    component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/erp/du/user/view/EditUserDrawer.vue'),
                    /* no children */
                  },
  _mergeRouteRecord(
                  {
                    path: 'updatepwd',
                    name: 'erp-du-user-view-updatepwd',
                    component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/erp/du/user/view/updatepwd.vue'),
                    /* no children */
                  },
  _definePage_default_31
  )
                ],
              }
            ],
          }
        ],
      },
      {
        path: 'dw',
        /* internal name: 'erp-dw' */
        /* no component */
        children: [
          {
            path: 'msg',
            /* internal name: 'erp-dw-msg' */
            /* no component */
            children: [
              {
                path: 'view',
                /* internal name: 'erp-dw-msg-view' */
                /* no component */
                children: [
  _mergeRouteRecord(
                  {
                    path: 'dw-msg',
                    name: 'erp-dw-msg-view-dw-msg',
                    component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/erp/dw/msg/view/dw-msg.vue'),
                    /* no children */
                  },
  _definePage_default_32
  ),
                  {
                    path: 'dw-msg-drawer',
                    name: 'erp-dw-msg-view-dw-msg-drawer',
                    component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/erp/dw/msg/view/dw-msg-drawer.vue'),
                    /* no children */
                  }
                ],
              }
            ],
          }
        ],
      }
    ],
  },
  _mergeRouteRecord(
  {
    path: '/forgot-password',
    name: 'forgot-password',
    component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/forgot-password.vue'),
    /* no children */
  },
  _definePage_default_33
  ),
  _mergeRouteRecord(
  {
    path: '/home',
    name: 'home',
    component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/home.vue'),
    /* no children */
  },
  _definePage_default_34
  ),
  _mergeRouteRecord(
  {
    path: '/login',
    name: 'login',
    component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/login.vue'),
    /* no children */
  },
  _definePage_default_35
  ),
  _mergeRouteRecord(
  {
    path: '/login-linebot',
    name: 'login-linebot',
    component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/login-linebot.vue'),
    /* no children */
  },
  _definePage_default_36
  ),
  _mergeRouteRecord(
  {
    path: '/not-authorized',
    name: 'not-authorized',
    component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/not-authorized.vue'),
    /* no children */
  },
  _definePage_default_37
  ),
  {
    path: '/nstc',
    /* internal name: 'nstc' */
    /* no component */
    children: [
      {
        path: 'view',
        /* internal name: 'nstc-view' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: 'bulletin',
            name: 'nstc-view-bulletin',
            component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/nstc/view/bulletin.vue'),
            /* no children */
          },
  _definePage_default_38
  ),
  _mergeRouteRecord(
          {
            path: 'rtp',
            name: 'nstc-view-rtp',
            component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/nstc/view/rtp.vue'),
            /* no children */
          },
  _definePage_default_39
  )
        ],
      }
    ],
  },
  _mergeRouteRecord(
  {
    path: '/register',
    name: 'register',
    component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/register.vue'),
    /* no children */
  },
  _definePage_default_40
  ),
  _mergeRouteRecord(
  {
    path: '/register-result',
    name: 'register-result',
    component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/register-result.vue'),
    /* no children */
  },
  _definePage_default_41
  ),
  {
    path: '/reset',
    /* internal name: 'reset' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: ':key',
        name: 'reset-key',
        component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/reset/[key].vue'),
        /* no children */
      },
  _definePage_default_42
  )
    ],
  },
  _mergeRouteRecord(
  {
    path: '/reset-passwd',
    name: 'reset-passwd',
    component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/reset-passwd.vue'),
    /* no children */
  },
  _definePage_default_43
  ),
  {
    path: '/tca',
    /* internal name: 'tca' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: 'tca',
        component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/tca/index.vue'),
        /* no children */
      },
  _definePage_default_44
  ),
      {
        path: 'erm',
        /* internal name: 'tca-erm' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: 'AnnualExpenseSummary',
            name: 'tca-erm-annual-expense-summary',
            component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/tca/erm/AnnualExpenseSummary.vue'),
            /* no children */
          },
  _definePage_default_45
  ),
  _mergeRouteRecord(
          {
            path: 'AssociationBudgetExpense',
            name: 'tca-erm-association-budget-expense',
            component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/tca/erm/AssociationBudgetExpense.vue'),
            /* no children */
          },
  _definePage_default_46
  ),
  _mergeRouteRecord(
          {
            path: 'AssociationBudgetSchedule',
            name: 'tca-erm-association-budget-schedule',
            component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/tca/erm/AssociationBudgetSchedule.vue'),
            /* no children */
          },
  _definePage_default_47
  ),
  _mergeRouteRecord(
          {
            path: 'ExpenseBorrow',
            name: 'tca-erm-expense-borrow',
            component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/tca/erm/ExpenseBorrow.vue'),
            /* no children */
          },
  _definePage_default_48
  ),
  _mergeRouteRecord(
          {
            path: 'ExpenseBorrowCenterList',
            name: 'tca-erm-expense-borrow-center-list',
            component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/tca/erm/ExpenseBorrowCenterList.vue'),
            /* no children */
          },
  _definePage_default_49
  ),
  _mergeRouteRecord(
          {
            path: 'ExpenseBorrowList',
            name: 'tca-erm-expense-borrow-list',
            component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/tca/erm/ExpenseBorrowList.vue'),
            /* no children */
          },
  _definePage_default_50
  ),
          {
            path: 'expenseChange',
            /* internal name: 'tca-erm-expense-change' */
            /* no component */
            children: [
              {
                path: 'ExpenseChangeAmount',
                name: 'tca-erm-expense-change-expense-change-amount',
                component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/tca/erm/expenseChange/ExpenseChangeAmount.vue'),
                /* no children */
              },
  _mergeRouteRecord(
              {
                path: 'ExpenseChangeMain',
                name: 'tca-erm-expense-change-expense-change-main',
                component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/tca/erm/expenseChange/ExpenseChangeMain.vue'),
                /* no children */
              },
  _definePage_default_51
  ),
              {
                path: 'ExpenseChangeMainDetaill',
                name: 'tca-erm-expense-change-expense-change-main-detaill',
                component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/tca/erm/expenseChange/ExpenseChangeMainDetaill.vue'),
                /* no children */
              },
              {
                path: 'ExpenseChangeOnlySchedule',
                name: 'tca-erm-expense-change-expense-change-only-schedule',
                component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/tca/erm/expenseChange/ExpenseChangeOnlySchedule.vue'),
                /* no children */
              },
              {
                path: 'ExpenseChangeOriginalAmount',
                name: 'tca-erm-expense-change-expense-change-original-amount',
                component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/tca/erm/expenseChange/ExpenseChangeOriginalAmount.vue'),
                /* no children */
              },
              {
                path: 'ExpenseChangeScheduleList',
                name: 'tca-erm-expense-change-expense-change-schedule-list',
                component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/tca/erm/expenseChange/ExpenseChangeScheduleList.vue'),
                /* no children */
              },
              {
                path: 'ExpenseChangeSignOffHistory',
                name: 'tca-erm-expense-change-expense-change-sign-off-history',
                component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/tca/erm/expenseChange/ExpenseChangeSignOffHistory.vue'),
                /* no children */
              }
            ],
          },
  _mergeRouteRecord(
          {
            path: 'ExpenseChange',
            name: 'tca-erm-expense-change',
            component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/tca/erm/ExpenseChange.vue'),
            /* no children */
          },
  _definePage_default_52
  ),
  _mergeRouteRecord(
          {
            path: 'ExpenseChangeCenterList',
            name: 'tca-erm-expense-change-center-list',
            component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/tca/erm/ExpenseChangeCenterList.vue'),
            /* no children */
          },
  _definePage_default_53
  ),
  _mergeRouteRecord(
          {
            path: 'ExpenseChangeList',
            name: 'tca-erm-expense-change-list',
            component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/tca/erm/ExpenseChangeList.vue'),
            /* no children */
          },
  _definePage_default_54
  ),
  _mergeRouteRecord(
          {
            path: 'ExpenseChangeReassign',
            name: 'tca-erm-expense-change-reassign',
            component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/tca/erm/ExpenseChangeReassign.vue'),
            /* no children */
          },
  _definePage_default_55
  ),
  _mergeRouteRecord(
          {
            path: 'ExpenseChangeSchedule',
            name: 'tca-erm-expense-change-schedule',
            component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/tca/erm/ExpenseChangeSchedule.vue'),
            /* no children */
          },
  _definePage_default_56
  ),
          {
            path: 'ExpenseFileUpload',
            name: 'tca-erm-expense-file-upload',
            component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/tca/erm/ExpenseFileUpload.vue'),
            /* no children */
          },
  _mergeRouteRecord(
          {
            path: 'ExpenseReimbursement',
            name: 'tca-erm-expense-reimbursement',
            component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/tca/erm/ExpenseReimbursement.vue'),
            /* no children */
          },
  _definePage_default_57
  ),
  _mergeRouteRecord(
          {
            path: 'ExpenseReimbursementCenterList',
            name: 'tca-erm-expense-reimbursement-center-list',
            component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/tca/erm/ExpenseReimbursementCenterList.vue'),
            /* no children */
          },
  _definePage_default_58
  ),
          {
            path: 'ExpenseReimbursementDialog',
            name: 'tca-erm-expense-reimbursement-dialog',
            component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/tca/erm/ExpenseReimbursementDialog.vue'),
            /* no children */
          },
  _mergeRouteRecord(
          {
            path: 'ExpenseReimbursementList',
            name: 'tca-erm-expense-reimbursement-list',
            component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/tca/erm/ExpenseReimbursementList.vue'),
            /* no children */
          },
  _definePage_default_59
  ),
          {
            path: 'ExpenseReimbursementPaymentVoucher',
            name: 'tca-erm-expense-reimbursement-payment-voucher',
            component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/tca/erm/ExpenseReimbursementPaymentVoucher.vue'),
            /* no children */
          },
  _mergeRouteRecord(
          {
            path: 'ExpenseReimbursementReassign',
            name: 'tca-erm-expense-reimbursement-reassign',
            component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/tca/erm/ExpenseReimbursementReassign.vue'),
            /* no children */
          },
  _definePage_default_60
  ),
          {
            path: 'ExpenseReimbursementSettlement',
            name: 'tca-erm-expense-reimbursement-settlement',
            component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/tca/erm/ExpenseReimbursementSettlement.vue'),
            /* no children */
          },
          {
            path: 'expenseRequest',
            /* internal name: 'tca-erm-expense-request' */
            /* no component */
            children: [
              {
                path: 'ExpenseConsumableCapitalItem',
                name: 'tca-erm-expense-request-expense-consumable-capital-item',
                component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/tca/erm/expenseRequest/ExpenseConsumableCapitalItem.vue'),
                /* no children */
              },
              {
                path: 'ExpensePersonAnnualItem',
                name: 'tca-erm-expense-request-expense-person-annual-item',
                component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/tca/erm/expenseRequest/ExpensePersonAnnualItem.vue'),
                /* no children */
              },
              {
                path: 'ExpenseRequestSchedule',
                name: 'tca-erm-expense-request-expense-request-schedule',
                component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/tca/erm/expenseRequest/ExpenseRequestSchedule.vue'),
                /* no children */
              },
              {
                path: 'ExpenseRequestScheduleList',
                name: 'tca-erm-expense-request-expense-request-schedule-list',
                component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/tca/erm/expenseRequest/ExpenseRequestScheduleList.vue'),
                /* no children */
              }
            ],
          },
  _mergeRouteRecord(
          {
            path: 'ExpenseRequest',
            name: 'tca-erm-expense-request',
            component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/tca/erm/ExpenseRequest.vue'),
            /* no children */
          },
  _definePage_default_61
  ),
  _mergeRouteRecord(
          {
            path: 'ExpenseRequestCenterList',
            name: 'tca-erm-expense-request-center-list',
            component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/tca/erm/ExpenseRequestCenterList.vue'),
            /* no children */
          },
  _definePage_default_62
  ),
  _mergeRouteRecord(
          {
            path: 'ExpenseRequestList',
            name: 'tca-erm-expense-request-list',
            component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/tca/erm/ExpenseRequestList.vue'),
            /* no children */
          },
  _definePage_default_63
  ),
  _mergeRouteRecord(
          {
            path: 'ExpenseRequestMain',
            name: 'tca-erm-expense-request-main',
            component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/tca/erm/ExpenseRequestMain.vue'),
            /* no children */
          },
  _definePage_default_64
  ),
  _mergeRouteRecord(
          {
            path: 'ExpenseRequestProject',
            name: 'tca-erm-expense-request-project',
            component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/tca/erm/ExpenseRequestProject.vue'),
            /* no children */
          },
  _definePage_default_65
  ),
  _mergeRouteRecord(
          {
            path: 'ExpenseRequestProjectCenterList',
            name: 'tca-erm-expense-request-project-center-list',
            component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/tca/erm/ExpenseRequestProjectCenterList.vue'),
            /* no children */
          },
  _definePage_default_66
  ),
  _mergeRouteRecord(
          {
            path: 'ExpenseRequestProjectList',
            name: 'tca-erm-expense-request-project-list',
            component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/tca/erm/ExpenseRequestProjectList.vue'),
            /* no children */
          },
  _definePage_default_67
  ),
  _mergeRouteRecord(
          {
            path: 'ExpenseRequestReassign',
            name: 'tca-erm-expense-request-reassign',
            component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/tca/erm/ExpenseRequestReassign.vue'),
            /* no children */
          },
  _definePage_default_68
  ),
  _mergeRouteRecord(
          {
            path: 'GoldPlanApply',
            name: 'tca-erm-gold-plan-apply',
            component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/tca/erm/GoldPlanApply.vue'),
            /* no children */
          },
  _definePage_default_69
  ),
  _mergeRouteRecord(
          {
            path: 'GoldPlanAthleteList',
            name: 'tca-erm-gold-plan-athlete-list',
            component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/tca/erm/GoldPlanAthleteList.vue'),
            /* no children */
          },
  _definePage_default_70
  ),
  _mergeRouteRecord(
          {
            path: 'GoldPlanMeetingRecords',
            name: 'tca-erm-gold-plan-meeting-records',
            component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/tca/erm/GoldPlanMeetingRecords.vue'),
            /* no children */
          },
  _definePage_default_71
  ),
          {
            path: 'ImageGallery',
            name: 'tca-erm-image-gallery',
            component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/tca/erm/ImageGallery.vue'),
            /* no children */
          },
          {
            path: 'LoadingInterface',
            name: 'tca-erm-loading-interface',
            component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/tca/erm/LoadingInterface.vue'),
            /* no children */
          },
  _mergeRouteRecord(
          {
            path: 'PaymentVoucherConfirm',
            name: 'tca-erm-payment-voucher-confirm',
            component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/tca/erm/PaymentVoucherConfirm.vue'),
            /* no children */
          },
  _definePage_default_72
  ),
  _mergeRouteRecord(
          {
            path: 'PaymentVoucherUpload',
            name: 'tca-erm-payment-voucher-upload',
            component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/tca/erm/PaymentVoucherUpload.vue'),
            /* no children */
          },
  _definePage_default_73
  ),
          {
            path: 'reassign',
            /* internal name: 'tca-erm-reassign' */
            /* no component */
            children: [
              {
                path: 'reassign',
                name: 'tca-erm-reassign-reassign',
                component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/tca/erm/reassign/reassign.vue'),
                /* no children */
              }
            ],
          },
  _mergeRouteRecord(
          {
            path: 'ReassignApplication',
            name: 'tca-erm-reassign-application',
            component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/tca/erm/ReassignApplication.vue'),
            /* no children */
          },
  _definePage_default_74
  ),
          {
            path: 'ReimbursementPaymentVoucher',
            name: 'tca-erm-reimbursement-payment-voucher',
            component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/tca/erm/ReimbursementPaymentVoucher.vue'),
            /* no children */
          },
          {
            path: 'ScheduleFromOtherApplyNo',
            name: 'tca-erm-schedule-from-other-apply-no',
            component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/tca/erm/ScheduleFromOtherApplyNo.vue'),
            /* no children */
          },
          {
            path: 'SummaryTable',
            name: 'tca-erm-summary-table',
            component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/tca/erm/SummaryTable.vue'),
            /* no children */
          },
  _mergeRouteRecord(
          {
            path: 'UserInfoComponent',
            name: 'tca-erm-user-info-component',
            component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/tca/erm/UserInfoComponent.vue'),
            /* no children */
          },
  _definePage_default_75
  )
        ],
      },
      {
        path: 'tnm',
        /* internal name: 'tca-tnm' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: 'AssociationAutoCompleteComponenet',
            name: 'tca-tnm-association-auto-complete-componenet',
            component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/tca/tnm/AssociationAutoCompleteComponenet.vue'),
            /* no children */
          },
  _definePage_default_76
  ),
  _mergeRouteRecord(
          {
            path: 'AssociationCounselorSettings',
            name: 'tca-tnm-association-counselor-settings',
            component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/tca/tnm/AssociationCounselorSettings.vue'),
            /* no children */
          },
  _definePage_default_77
  ),
  _mergeRouteRecord(
          {
            path: 'CountryAreaCode',
            name: 'tca-tnm-country-area-code',
            component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/tca/tnm/CountryAreaCode.vue'),
            /* no children */
          },
  _definePage_default_78
  ),
  _mergeRouteRecord(
          {
            path: 'ExpensePerDiem',
            name: 'tca-tnm-expense-per-diem',
            component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/tca/tnm/ExpensePerDiem.vue'),
            /* no children */
          },
  _definePage_default_79
  ),
          {
            path: 'ExpenseReimbursementApplication',
            name: 'tca-tnm-expense-reimbursement-application',
            component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/tca/tnm/ExpenseReimbursementApplication.vue'),
            /* no children */
          },
  _mergeRouteRecord(
          {
            path: 'FnAssociationCounselorSettings',
            name: 'tca-tnm-fn-association-counselor-settings',
            component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/tca/tnm/FnAssociationCounselorSettings.vue'),
            /* no children */
          },
  _definePage_default_80
  ),
  _mergeRouteRecord(
          {
            path: 'PlanProjectListQuery',
            name: 'tca-tnm-plan-project-list-query',
            component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/tca/tnm/PlanProjectListQuery.vue'),
            /* no children */
          },
  _definePage_default_81
  ),
  _mergeRouteRecord(
          {
            path: 'ProjectCreationAndPublication',
            name: 'tca-tnm-project-creation-and-publication',
            component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/tca/tnm/ProjectCreationAndPublication.vue'),
            /* no children */
          },
  _definePage_default_82
  ),
          {
            path: 'ProjectCreationAndPublicationDialog',
            name: 'tca-tnm-project-creation-and-publication-dialog',
            component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/tca/tnm/ProjectCreationAndPublicationDialog.vue'),
            /* no children */
          },
  _mergeRouteRecord(
          {
            path: 'ProjectListCenter',
            name: 'tca-tnm-project-list-center',
            component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/tca/tnm/ProjectListCenter.vue'),
            /* no children */
          },
  _definePage_default_83
  ),
  _mergeRouteRecord(
          {
            path: 'ProjectScheduleManagement',
            name: 'tca-tnm-project-schedule-management',
            component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/tca/tnm/ProjectScheduleManagement.vue'),
            /* no children */
          },
  _definePage_default_84
  ),
  _mergeRouteRecord(
          {
            path: 'ReimburseItem',
            name: 'tca-tnm-reimburse-item',
            component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/tca/tnm/ReimburseItem.vue'),
            /* no children */
          },
  _definePage_default_85
  ),
  _mergeRouteRecord(
          {
            path: 'StatusComponenet',
            name: 'tca-tnm-status-componenet',
            component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/tca/tnm/StatusComponenet.vue'),
            /* no children */
          },
  _definePage_default_86
  ),
  _mergeRouteRecord(
          {
            path: 'TrainingApplicationList',
            name: 'tca-tnm-training-application-list',
            component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/tca/tnm/TrainingApplicationList.vue'),
            /* no children */
          },
  _definePage_default_87
  ),
  _mergeRouteRecord(
          {
            path: 'TrainingApplicationQueryList',
            name: 'tca-tnm-training-application-query-list',
            component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/tca/tnm/TrainingApplicationQueryList.vue'),
            /* no children */
          },
  _definePage_default_88
  ),
  _mergeRouteRecord(
          {
            path: 'TrainingListPrint',
            name: 'tca-tnm-training-list-print',
            component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/tca/tnm/TrainingListPrint.vue'),
            /* no children */
          },
  _definePage_default_89
  ),
  _mergeRouteRecord(
          {
            path: 'TrainingPlanApplication',
            name: 'tca-tnm-training-plan-application',
            component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/tca/tnm/TrainingPlanApplication.vue'),
            /* no children */
          },
  _definePage_default_90
  ),
  _mergeRouteRecord(
          {
            path: 'TrainingPlanApplicationList',
            name: 'tca-tnm-training-plan-application-list',
            component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/tca/tnm/TrainingPlanApplicationList.vue'),
            /* no children */
          },
  _definePage_default_91
  ),
  _mergeRouteRecord(
          {
            path: 'TrainingPlanApplicationListAssociation',
            name: 'tca-tnm-training-plan-application-list-association',
            component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/tca/tnm/TrainingPlanApplicationListAssociation.vue'),
            /* no children */
          },
  _definePage_default_92
  ),
  _mergeRouteRecord(
          {
            path: 'TrainingTeamApplication',
            name: 'tca-tnm-training-team-application',
            component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/tca/tnm/TrainingTeamApplication.vue'),
            /* no children */
          },
  _definePage_default_93
  ),
  _mergeRouteRecord(
          {
            path: 'UserInfoComponent',
            name: 'tca-tnm-user-info-component',
            component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/tca/tnm/UserInfoComponent.vue'),
            /* no children */
          },
  _definePage_default_94
  )
        ],
      }
    ],
  },
  _mergeRouteRecord(
  {
    path: '/tca-home',
    name: 'tca-home',
    component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/tca-home.vue'),
    /* no children */
  },
  _definePage_default_95
  ),
  {
    path: '/tco',
    /* internal name: 'tco' */
    /* no component */
    children: [
      {
        path: 'ar',
        /* internal name: 'tco-ar' */
        /* no component */
        children: [
          {
            path: 'AccountReview',
            name: 'tco-ar-account-review',
            component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/tco/ar/AccountReview.vue'),
            /* no children */
          },
          {
            path: 'AccountReviewStatusQuery',
            name: 'tco-ar-account-review-status-query',
            component: () => import('/var/jenkins_home/workspace/s2-nstc-tca/frontend/src/pages/tco/ar/AccountReviewStatusQuery.vue'),
            /* no children */
          }
        ],
      }
    ],
  }
]
